export enum PricingFilterType {
  PROGRAM = 'program',
  PRODUCT = 'product',
}
